import MainLayout from "./MainRouter";

export default MainLayout;
